<template>
  <div class="property-filter-item flex-container flex-row flex-verti-center">
    <span class="label">{{ item.name }}</span>
    <el-input
      v-if="item.valueType==='String'"
      v-model="item.value"
      :placeholder="$t('common.inputPlaceholder')"
      @change="handleTextInput"
     />
    <el-select
      v-if="item.valueType==='Enum' || item.valueType==='Logic'"
      class="filter-select"
      v-model="item.value"
      :placeholder="$t('common.selectPlaceholder')"
      clearable
      @change="(value)=> item.valueType==='Enum' ? handleEnumSelect(value) : handleLogicSelect(value)"
      >
      <el-option
        v-for="v in item.values"
        :key="v.value"
        :label="v.name"
        :value="v.value"
        />
    </el-select>  
    <div v-if="item.valueType==='Int'||item.valueType==='Number'" class="filter-range flex-container flex-row flex-verti-center">
      <number-range :item="item" @range-changed="hanldeNumberRange" />
      <span v-if="item.unit" class="range-unit">{{ item.unit }}</span>
    </div>
  </div>  
</template>
<script>
import NumberRange from './NumberRange'
export default {
  // valueType:Logic-是否的下拉；String-输入框；Number&Int-最小值and最大值；Enum-枚举值
  name: 'PropertyFilterItem',
  components: { NumberRange },
  props: {
    formItem: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      item: {}
    }
  },
  watch: {
    formItem: {
      handler(val) {
        this.item = { ...val }
        if (val.valueType === 'Logic') {
          this.item.values = [{ name: this.$t('common.yes'), value: true }, { name: this.$t('common.no'), value: false }]
        } else if (val.valueType === 'Enum') {
          this.item.values = this.getEnumOptions(val.values)
        }
      },
      immediate: true
    }
  },
  methods: {
    getEnumOptions(values) {
      const names = Object.keys(values)
      return names.map((n) => {
        return {
          name: values[n],
          value: n
        }
      })
    },
    codeOrGuid() {
      return this.item.isConfigurable ? { code: this.item.code } : { guid: this.item.guid }
    },
    handleTextInput(val) {
      if (this.item.value === val) {
        return
      }
      this.item.value = val

      const filter = {
        code: this.item.code,
        guid: this.item.guid,
        isConfigurable: this.item.isConfigurable,
        parameterType: 'String',
        queryType: 'CONTAIN',
        isValid: Boolean(val),
        value: val
      }
      this.$emit('item-changed', filter)
    },
    hanldeNumberRange({ value, isValid }) {
      const filter = {
        code: this.item.code,
        guid: this.item.guid,
        isConfigurable: this.item.isConfigurable,
        isValid,
      }
      const { from, to } = value
      filter.parameterType = this.item.valueType === 'Int' ? 'Integer' : 'Double'
      if (from || to) {
        if (from && !to) {
          filter.queryType = 'GTE'
          filter.value = from
        } else if (!from && to) {
          filter.queryType = 'LTE'
          filter.value = to
        } else if (Number(from) < Number(to)) {
          filter.queryType = 'RANGE_TE'
          filter.from = from
          filter.to = to
        } else if (Number(from) === Number(to)) {
          filter.queryType = 'EQUAL'
          filter.value = from
        }
      } else {
        filter.isValid = 'EMPTY' // 上层删除该属性
      }
      this.$emit('item-changed', filter)
    },
    handleEnumSelect(value) {
      this.item.value = value
      this.$emit('item-changed', {
        code: this.item.code,
        guid: this.item.guid,
        isConfigurable: this.item.isConfigurable,
        parameterType: 'Enum',
        queryType: 'EQUAL',
        value,
        isValid: value !== ''
      })
    },
    handleLogicSelect(value) {
      this.item.value = value
      this.$emit('item-changed', {
        code: this.item.code,
        guid: this.item.guid,
        isConfigurable: this.item.isConfigurable,
        parameterType: 'Integer',
        queryType: 'EQUAL',
        value: value ? 1 : 0,
        isValid: value !== ''
      })
    }
  }
}
</script>
<style lang='less' scoped>
.property-filter-item{
  height: 24px;
  .label{
    height: 24px;
    line-height: 24px;
    margin-right: 6px;
  }
  .range-unit{
    margin-left: 4px;
  }
  .filter-input{
    display: inline-block;
  }
  .filter-select{
    width: 116px;
  }
}
</style>
